import React, { useEffect } from "react";
import { inject, observer } from 'mobx-react';
import MaterialTable, { MTableToolbar } from "material-table";
import { qarManagersOptions } from '../../helper/constants';
import { qarFindingsColumns } from "../Reporting/Constants";
import Grid from "@material-ui/core/Grid";
import { isValidDate } from '../../helper/constants';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import { Typography, IconButton } from '@material-ui/core';
import { HtmlTooltip } from '../HtmlTooltip/HtmlTooltip';


const QarFindingsByAccount = inject('RootStore')(observer(({ RootStore }) => {
    useEffect((() => {
        RootStore.qarStore.getAllFindingsByAccountId(RootStore.qarStore.currentlySelectedAccountForReview.id, RootStore.qarStore.currentComplianceReviewId);
    }), []);

    const tableName = `${RootStore.qarStore.currentlyReviewedSystemForReview.name} / ${RootStore.qarStore.currentlySelectedAccountForReview.name} / Findings`

    return (
        <>
            <MaterialTable
                title=""
                data={RootStore.qarStore.findingsByAccount}
                columns={qarFindingsColumns}
                options={qarManagersOptions}
                localization={{
                    toolbar: {
                        exportCSVName: "Export as XLSX",
                    }
                }}
                components={{
                    Toolbar: (tableProps) => (
                        <Grid
                            container
                            direction="row"
                            justifyContent="flex-start"
                            alignItems="center"
                            spacing={3}
                        >
                            <Grid item sm={4}>
                                <h4 style={{ marginLeft: '10px' }}>
                                    {tableName}
                                </h4>
                            </Grid>
                            <Grid item sm={3} style={{ textAlign: 'right' }}>
                                <h4>{new Date(RootStore.qarStore.creationDate).toUTCString()}</h4>
                                ({new Date(RootStore.qarStore.creationDate).toLocaleString()} local time)
                            </Grid>
                            <HtmlTooltip
                                title={
                                    <React.Fragment>
                                        <Typography color="inherit" variant="caption">
                                            This is the compliance review creation date.
                                        </Typography>
                                    </React.Fragment>
                                }
                            >
                                <IconButton aria-label="delete" size="small">
                                    <HelpOutlineIcon fontSize="inherit" />
                                </IconButton>
                            </HtmlTooltip>
                            <Grid item sm={4} style={{ textAlign: 'left' }}>
                                <MTableToolbar {...tableProps} />
                            </Grid>
                        </Grid>
                    )
                }}
            />
        </>
    )
}));

export default QarFindingsByAccount;